<template>
    <div>
        <Header/>
        <div v-if="IsLoading" class="spinner-border" style="position:fixed; top:50%; left:50%" role="status">
                <span class="sr-only">Loading...</span>
        </div>
        <section v-else class="ftco-section">
            <div class="container-fluid">
                <div class="row justify-content-center">
                    <div class="col-md-6 text-center mb-4">
                        <h2 class="heading-section">{{custName}}</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="table-wrap">
                            <table class="table myaccordion table-hover" id="accordion">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Date</th>
                                        <th>Expiry Date</th>
                                        <th>Doc No.</th>
                                        <th>Void</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-on:dblclick="()=> goto(item)" v-for="(item, i) in items" :key="item.DocID">
                                        <th scope="row">{{i+1}}.</th>
                                        <td>{{parseToDateString(item.DocDate)}}</td>
                                        <td>{{parseToDateString(item.ExpiryDate)}}</td>
                                        <td>{{item.DocNo}}</td>
                                        <td>
                                            <span v-if="item.Void">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="green" class="bi bi-check-circle" viewBox="0 0 16 16">
                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                    <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                                                    </svg>
                                            </span>
                                            <span v-else>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" class="bi bi-x-circle" viewBox="0 0 16 16">
                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                                    </svg>
                                                
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>
<script lang="ts" src="./SORecom.ts"></script>